export default "__VITE_ASSET__TFvnfANA__"